/**
 * Formats event date text (e.g. Shopify date metafield via dynamic source) as dd.mm.yyyy.
 */
class BlogPostEventDate extends HTMLElement {
  connectedCallback() {
    this.#format();
  }

  #format() {
    const output = this.querySelector('[data-event-date-output]');
    if (!output) return;

    const raw = this.dataset.date?.trim() || output.textContent?.trim() || '';
    if (!raw) return;

    const formatted = formatEventDate(raw);
    if (formatted) output.textContent = formatted;
  }
}

/**
 * @param {string} input
 * @returns {string}
 */
function formatEventDate(input) {
  if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) return input;

  const isoMatch = input.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    return `${isoMatch[3]}.${isoMatch[2]}.${isoMatch[1]}`;
  }

  const parsed = new Date(input);
  if (Number.isNaN(parsed.getTime())) return input;

  const dd = String(parsed.getDate()).padStart(2, '0');
  const mm = String(parsed.getMonth() + 1).padStart(2, '0');
  const yyyy = parsed.getFullYear();

  return `${dd}.${mm}.${yyyy}`;
}

if (!customElements.get('blog-post-event-date')) {
  customElements.define('blog-post-event-date', BlogPostEventDate);
}
